import script from "./MailSubject.vue?vue&type=script&setup=true&lang=ts"
export * from "./MailSubject.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__